<template>
  <div class="py-4">
    <div class="uppercase text-cal-525252 text-xs">{{ label }}</div>
    <div class="py-1 text-sm"><slot></slot></div>
  </div>
</template>
<script>
export default {
  name: 'DetailItem',
  props: {
    label: {
      type: String,
      required: true,
    }
  }
}
</script>
